import { render } from "./PropertiesStatusRadio.vue?vue&type=template&id=595c8666&scoped=true"
import script from "./PropertiesStatusRadio.vue?vue&type=script&lang=js"
export * from "./PropertiesStatusRadio.vue?vue&type=script&lang=js"

import "./PropertiesStatusRadio.vue?vue&type=style&index=0&id=595c8666&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-595c8666"]])

export default __exports__